import { ControllerStore } from '@ayocore/platform/client/controllers/ControllerStore';
import logger from '@ayocore/platform/common/helpers/logger';
import type { SalesSummaryResult, SalesSummarySettings } from '../common/types';

interface State {
  data: SalesSummaryResult | null;
  loading: boolean;
  error: string | null;
}

/** Загрузка одной сводки; смена фильтров и размонтирование отменяют применение старого ответа. */
export class SalesSummaryWidgetController extends ControllerStore<State> {
  private version = 0;

  constructor(
    private readonly getSummary: (settings: SalesSummarySettings) => Promise<SalesSummaryResult>
  ) {
    super({ data: null, loading: true, error: null });
  }

  async load(settings: SalesSummarySettings): Promise<void> {
    const version = ++this.version;
    this.setState({ data: null, loading: true, error: null });
    try {
      const data = await this.getSummary(settings);
      if (version === this.version) this.setState({ data, loading: false, error: null });
    } catch (error) {
      if (version !== this.version) return;
      logger.error('Failed to load CRM sales summary:', error);
      this.setState({
        data: null,
        loading: false,
        error: error instanceof Error ? error.message : 'Не удалось загрузить финансовую сводку',
      });
    }
  }

  cancelLoad(): void {
    this.version += 1;
  }
}

/** Сравнение сумм; при нулевой/отрицательной базе процент роста не определяем. */
export function getSummaryChange(current: number | null, previous: number | null): number | null {
  if (current == null || previous == null || previous <= 0) return null;
  return ((current - previous) / previous) * 100;
}
